/* eslint-disable import/no-anonymous-default-export */
/**
 * 맘카페/당근 배포 신청 캠페인 설정
 */
import RefundBadge from "../components/RefundBadge";
export default {
  id: "adMomCafeCarrot",
  title: "맘카페/당근 배포 신청",

  api: {
    list: {
      method: "GET",
      url: "/advertisement/admin/momcafeCarrots",
    },
    count: {
      method: "GET",
      url: "/advertisement/admin/momcafeCarrots/count",
    },
    submitted: {
      method: "POST",
      url: "/advertisement/admin/momcafeCarrots/submitted",
    },
    paid: {
      method: "POST",
      url: "/advertisement/admin/momcafeCarrots/paid",
    },
    complete: {
      method: "POST",
      url: "/advertisement/admin/momcafeCarrots/complete",
    },
    refund: {
      method: "POST",
      url: "/advertisement/admin/campaigns/refund",
      version: 2,
    },
    delete: {
      method: "DELETE",
      url: "/advertisement/admin/momcafeCarrots",
    },
  },

  filters: {
    default: {
      status: "전체",
      submitDate: "",
      keyword: "",
      page: 1,
      limit: 50,
      submitted: "전체",
      paid: "전체",
      productTypes: [],
    },
    schema: [
      {
        name: "productTypes",
        label: "상품 타입",
        type: "checkbox-group",
        options: [
          { value: "mom_cafe", label: "맘카페 배포" },
          { value: "carrot", label: "당근 배포" },
        ],
      },
      {
        name: "keyword",
        label: "검색",
        type: "text",
        placeholder: "신청자, 플레이스명",
      },
      {
        name: "submitDate",
        label: "접수일",
        type: "date",
      },
      {
        name: "submitted",
        label: "접수여부",
        type: "select",
        options: [
          { value: "전체", label: "전체" },
          { value: "complete", label: "접수완료" },
          { value: "notComplete", label: "미접수" },
        ],
      },
      {
        name: "paid",
        label: "결제상태",
        type: "select",
        options: [
          { value: "전체", label: "전체" },
          { value: "complete", label: "결제완료" },
          { value: "notComplete", label: "미결제" },
          { value: "refund", label: "환불" },
        ],
      },
      {
        name: "status",
        label: "상태",
        type: "select",
        options: [
          { value: "전체", label: "전체" },
          { value: "waiting", label: "대기중" },
          { value: "processing", label: "진행중" },
          { value: "completed", label: "종료" },
        ],
      },
    ],
  },

  summary: {
    fields: [
      { key: "totalCount", label: "총 신청" },
      { key: "waitingCount", label: "대기중" },
      { key: "processingCount", label: "진행중" },
      { key: "completedCount", label: "종료" },
    ],
  },

  table: {
    keyField: "adMomCafeCarrotId",
    columns: [
      {
        key: "adCampaignMetaId",
        label: "아이디",
        center: true,
      },
      {
        key: "createdAt",
        label: "캐랭접수시간",
        center: true,
        render: (row) => {
          if (!row.createdAt) return "";
          const [date, time] = row.createdAt.split(" ");
          return (
            <>
              <div>{date}</div>
              <div>{time?.slice(0, 8)}</div>
            </>
          );
        },
      },
      {
        key: "userName",
        label: "신청자(ID)\n상태",
        center: true,
        render: (row) => (
          <>
            <div>
              {row.userName}
              {row.userId ? ` (${row.userId})` : ""}
            </div>
            <div>
              <span className={`badge badge-${row.status}`}>{getStatusLabel(row.status)}</span>
            </div>
          </>
        ),
      },
      {
        key: "submitDate",
        label: "접수일",
        center: true,
        render: (row) => (row.submitDate ? row.submitDate.split("T")[0] : ""),
      },
      {
        key: "title",
        label: "상품타입\n총수량\n총금액(단가)",
        center: true,
        render: (row) => {
          const parseReviewType = (reviewType) => {
            if (!reviewType) return { questionCount: 0, reviewCount: 0 };
            try {
              const arr = typeof reviewType === "string" ? JSON.parse(reviewType) : reviewType;
              if (!Array.isArray(arr)) return { questionCount: 0, reviewCount: 0 };
              const question = arr.find((item) => item?.type === "question");
              const review = arr.find((item) => item?.type === "review");
              return {
                questionCount: question?.count ?? 0,
                reviewCount: review?.count ?? 0,
              };
            } catch {
              return { questionCount: 0, reviewCount: 0 };
            }
          };

          const { questionCount, reviewCount } = parseReviewType(row.reviewType);
          let quantityText = "";
          if (questionCount > 0 && reviewCount > 0) {
            quantityText = `질문: ${questionCount}건, 후기: ${reviewCount}건`;
          } else if (questionCount > 0) {
            quantityText = `질문: ${questionCount}건`;
          } else if (reviewCount > 0) {
            quantityText = `후기: ${reviewCount}건`;
          } else {
            quantityText = `${row.totalQuantity}건`;
          }

          return (
            <>
              <div>{row.title}</div>
              <div>{quantityText}</div>
              <div>
                {Math.round(row.totalAmount)?.toLocaleString()}원 (
                {Math.round(row.totalAmount / 1.1 / row.totalQuantity)?.toLocaleString()}원)
              </div>
            </>
          );
        },
      },
      {
        key: "placeName",
        label: "플레이스명 또는 상품명\n연락처\n플레이스 또는 상품 URL",
        center: true,
        render: (row) => (
          <>
            <div>{row.placeName}</div>
            <div>{row.phoneNum || ""}</div>
            <div>
              {row.placeUrl && (
                <a href={row.placeUrl} target="_blank" rel="noopener noreferrer">
                  {row.placeUrl}
                </a>
              )}
            </div>
          </>
        ),
      },
      {
        key: "region",
        label: "희망지역\n레퍼런스\n맘카페 url",
        center: true,
        render: (row) => (
          <>
            <div>{row.region}</div>
            <div>{row.reference || ""}</div>
            <div>
              {row.momCafeUrls && row.momCafeUrls.length > 0 && (
                <span
                  style={{
                    color: "#007bff",
                    cursor: "pointer",
                    textDecoration: "underline",
                  }}
                  title={row.momCafeUrls.join("\n")}
                  data-mom-cafe-urls={JSON.stringify(row.momCafeUrls)}
                >
                  링크
                </span>
              )}
            </div>
          </>
        ),
      },
      {
        key: "startDate",
        label: "희망 시작일",
        center: true,
        render: (row) => (row.startDate ? row.startDate.split("T")[0] : ""),
      },
      {
        key: "guideline",
        label: "요청사항",
        center: true,
        render: (row) => (
          <div className="guideline-textbox" data-momcafe-id={row.adMomCafeCarrotId} title={row.guideline || "-"}>
            {row.guideline || "-"}
          </div>
        ),
      },
      {
        key: "paymentType",
        label: "결제방법\n결제상태",
        center: true,
        render: (row) => (
          <>
            <div>{row.paymentType === "card" ? "카드" : row.paymentType === "v_bank" ? "가상계좌" : row.paymentType === "point" ? "포인트 결제" : "계좌이체"}</div>
            <div>
              {row.isPaid === 2 ? (
                <RefundBadge
                  refundedAmount={row.refundedAmount ?? 0}
                  remainingAmount={row.remainingAmount ?? 0}
                  refundDate={row.refundDate}
                />
              ) : (
                <span className={`badge badge-${row.isPaid === 1 ? "결제완료" : "미결제"}`}>
                  {row.isPaid === 1 ? "결제완료" : "미결제"}
                </span>
              )}
            </div>
          </>
        ),
      },
      {
        key: "report",
        label: "리포트",
        center: true,
        render: (row) => (
          <button
            type="button"
            className="status-btn submitted"
            data-campaign-meta-id={row.adCampaignMetaId}
            data-type={row.type}
            data-place-name={row.placeName || ""}
          >
            리포트
          </button>
        ),
      },
      {
        key: "notification",
        label: "알림톡",
        center: true,
        render: (row) => {
          const productName = row.title || "맘카페/당근 배포 신청";

          return (
            <button
              type="button"
              className="notification-btn"
              data-campaign-meta-id={row.adCampaignMetaId}
              data-action="notification"
              data-user-id={row.userId}
              data-product-name={productName}
              data-submitted-at={row.createdAt || ""}
              data-purchase-amount={row.totalAmount ?? ""}
              onClick={(e) => e.stopPropagation()}
            >
              알림톡
            </button>
          );
        },
      },
      {
        key: "memo",
        label: "메모",
        center: true,
        render: (row) => (
          <button
            type="button"
            className={row.memo ? "memo-btn has-memo" : "memo-btn"}
            data-action="memo"
            data-campaign-meta-id={row.adCampaignMetaId}
            data-memo={row.memo || ""}
            onClick={(e) => e.stopPropagation()}
          >
            {row.memo
              ? <span className="memo-preview">{row.memo}</span>
              : "메모"}
          </button>
        ),
      },
    ],
  },

  actions: [
    {
      id: "submitted",
      label: "접수/취소",
      actionType: "submitted",
      enabledWhen: (selectedIds) => selectedIds.length > 0,
      payloadBuilder: (selectedIds, items) => {
        const hasUnsubmitted = items.some(
          (item) => selectedIds.includes(item.adMomCafeCarrotId) && item.isSubmitted !== 1,
        );
        return {
          adMomCafeCarrotIds: selectedIds,
          toggleValue: hasUnsubmitted ? 1 : 0,
        };
      },
    },
    {
      id: "paid",
      label: "결제완료",
      actionType: "paid",
      enabledWhen: (selectedIds, items) => {
        if (selectedIds.length === 0) return false;
        const alreadyPaid = items.some((item) => selectedIds.includes(item.adMomCafeCarrotId) && item.isPaid === 1);
        return !alreadyPaid;
      },
      payloadBuilder: (selectedIds) => ({
        adMomCafeCarrotIds: selectedIds,
        toggleValue: 1,
      }),
    },
    {
      id: "complete",
      label: "완료/취소",
      actionType: "complete",
      enabledWhen: (selectedIds) => selectedIds.length > 0,
      confirm: (selectedIds, items) => {
        const hasUncompleted = items.some(
          (item) => selectedIds.includes(item.adMomCafeCarrotId) && item.isCompleted !== 1,
        );
        return hasUncompleted ? "선택한 신청을 완료 처리하시겠습니까?" : "선택한 신청을 취소 처리하시겠습니까?";
      },
      payloadBuilder: (selectedIds, items) => {
        const hasUncompleted = items.some(
          (item) => selectedIds.includes(item.adMomCafeCarrotId) && item.isCompleted !== 1,
        );
        return {
          adMomCafeCarrotIds: selectedIds,
          toggleValue: hasUncompleted ? 1 : 0,
        };
      },
    },
    {
      id: "refund",
      label: "환불",
      actionType: "refund",
      requires: "ad.campaign.refund", // 권한 없으면 버튼 숨김 (R-FE-04)
      enabledWhen: (selectedIds, items) => {
        if (selectedIds.length === 0) return false;
        return items.some(
          (item) => selectedIds.includes(item.adMomCafeCarrotId) && (item.isPaid === 1 || item.isPaid === 2) && (item.remainingAmount ?? item.totalAmount ?? 0) > 0
        );
      },
    },
    {
      id: "delete",
      label: "삭제",
      actionType: "delete",
      enabledWhen: (selectedIds) => selectedIds.length > 0,
      confirm: "선택한 신청을 삭제하시겠습니까?",
      payloadBuilder: (selectedIds) => ({
        adMomCafeCarrotIds: selectedIds,
      }),
    },
  ],

  download: {
    type: "xlsx",
    fileName: "맘카페당근_신청목록.xlsx",
    sheetName: "맘카페당근신청목록",
    transformRow: (row) => {
      const parseReviewType = (reviewType) => {
        if (!reviewType) return { questionCount: 0, reviewCount: 0 };
        try {
          const arr = typeof reviewType === "string" ? JSON.parse(reviewType) : reviewType;
          if (!Array.isArray(arr)) return { questionCount: 0, reviewCount: 0 };
          const question = arr.find((item) => item?.type === "question");
          const review = arr.find((item) => item?.type === "review");
          return {
            questionCount: question?.count ?? 0,
            reviewCount: review?.count ?? 0,
          };
        } catch {
          return { questionCount: 0, reviewCount: 0 };
        }
      };

      const { questionCount, reviewCount } = parseReviewType(row.reviewType);

      const getProductTypeLabel = (title) => {
        if (!title || typeof title !== "string") return title || "";
        if (title.includes("당근")) return "당근 배포";
        if (title.includes("맘 카페")) return "맘카페 배포";
        return title;
      };

      return {
        신청자: row.userName || "",
        접수일: row.submitDate ? row.submitDate.split("T")[0] : "",
        상품타입: getProductTypeLabel(row.title) || "",
        질문형: questionCount || 0,
        후기형: reviewCount || 0,
        총수량: `${row.totalQuantity}건`,
        총금액: Math.round(row.totalAmount) || 0,
        단가: Math.round(row.totalAmount / 1.1 / row.totalQuantity) || 0,
        플레이스명: row.placeName || "",
        연락처: row.phoneNum || "",
        플레이스URL: row.placeUrl || "",
        희망지역: row.region || "",
        레퍼런스: row.reference || "",
        맘카페URL: row.momCafeUrls ? row.momCafeUrls.join(", ") : "",
        희망시작일: row.startDate ? row.startDate.split("T")[0] : "",
        요청사항: row.guideline || "",
      };
    },
  },
};

function getStatusLabel(status) {
  switch (status) {
    case "waiting":
      return "대기중";
    case "processing":
      return "진행중";
    case "completed":
      return "종료";
    default:
      return status;
  }
}
